import { HttpClient } from "../api/httpclient.service";


export interface PaymentRequest {
  subscription_package_id: number;
  is_trial: boolean;
  is_pre_paid: boolean;
  SingleUseToken: string;
}

export class PaymentService extends HttpClient {
  constructor() {
    super();
  }

  async process_payment(subscription_package: any, SingleUseToken: string): Promise<any> {
    try {
      const payload: PaymentRequest = {
        subscription_package_id: subscription_package.id,
        is_trial: subscription_package.is_trial,
        is_pre_paid: subscription_package.is_pre_paid || false,
        SingleUseToken
      };
      const response = await this.post('/payment/process_payment', payload);
      return response;
    } catch (error: any) {
      console.error('Process payment error:', error.response?.data || error.message);
      throw error;
    }
  }
}
